import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loader" }
const _hoisted_2 = { class: "factCard loading" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "details" }

import { Vue3Lottie } from "vue3-lottie";
import "vue3-lottie/dist/style.css";

export default /*@__PURE__*/_defineComponent({
  __name: 'Loader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Vue3Lottie), {
            animationLink: `/assets/lottie/surveyTool/loader.json`,
            loop: true,
            height: "auto"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "factTitle" }, " Curating all the information you'll need to decide if we're a good fit ", -1))
        ])
      ])
    ])
  ]))
}
}

})